import axios from 'axios';

class EventPing {
  start(prefix = "") {
    this.prefix = prefix;
    setInterval(this.intervalHandler.bind(this), 10000);
  }

  intervalHandler() {
    axios.get(`${this.prefix}/ping`).then(function () {
      console.log("Ping sent")
    })
  }
}

export default EventPing;
